'use strict';

angular.module('formonlineApp')
    .controller('DelaifiduController', function ($scope, $log, $stateParams, $translate, $sce, ObjectUtils, StringUtil,
                                                 PrintUtil, DelaiFiduService, $window, $interval, FrontendlogService,
                                                 ErrorUtil, ValidationUtil, ERROR_PREFIX, IframeService) {

        var vm = $scope;

        var localStorageKey = 'formOnline.fiduciaire';

        vm.formHelper = {};
        vm.formHelper.type = 'FORM';
        vm.formHelper.step = 1;
        vm.formHelper.recaptchaSuccess = false;
        vm.formHelper.fileUploadError = null;
        vm.formHelper.saveHeader = false;
        vm.formHelper.saved = $window.localStorage.getItem(localStorageKey);
        vm.formHelper.dateDemande = new Date();
        vm.formHelper.valid = false;
        vm.formHelper.errorMsg = null;
        vm.formHelper.showValidationMsg = false;

        vm.errors = {};
        vm.warnings = {};

        var delaiFiduciaireOriginal = {
            demandesDelai: [{
                index: 1
            }]
        };

        if (vm.formHelper.saved != null) {
            delaiFiduciaireOriginal.fiduciaire = JSON.parse(vm.formHelper.saved);
            delaiFiduciaireOriginal.fiduciaire.periodeFiscale = new Date().getFullYear() - 1;
            vm.formHelper.saveHeader = true;
        } else {
            delaiFiduciaireOriginal.fiduciaire = {
                periodeFiscale: new Date().getFullYear() - 1,
                langue: 'fr'
            };
        }

        vm.delaiFiduciaire = angular.copy(delaiFiduciaireOriginal);

        if ($stateParams.locale === 'de') {
            vm.delaiFiduciaire.fiduciaire.langue = $stateParams.locale;
            $translate.use($stateParams.locale);
            $('.datepicker').datepicker({
                language: $stateParams.locale
            });
        } else {
            vm.delaiFiduciaire.fiduciaire.langue = 'fr';
            $translate.use('fr');
            $('.datepicker').datepicker({
                language: 'fr'
            });
        }

        var filterErrors = function (errors) {
            vm.errors = {};
            angular.forEach(errors, function (value) {
                if (value.index > 0) {
                    vm.errors[value.index + value.field] = value;
                }
            });
        };

        var filterWarnings = function(warnings) {
            vm.warnings = {};
            angular.forEach(warnings, function (value) {
                if (value.index > 0) {
                    vm.warnings[value.index + value.field] = value;
                }
            });
        };

        vm.treatError = function(error, frontend) {
            vm.formHelper.errorMsg = ErrorUtil.translateError(error, ERROR_PREFIX + 'error.internalServerError', ERROR_PREFIX);

            ErrorUtil.treatError(error, frontend, function() {
                FrontendlogService.logCaptcha(vm.delaiFiduciaire.recaptchaResponse, error, function (value) {
                    // We don't care, it's logging
                }, function (err) {
                    // We don't care, it's logging
                });
            });
        };

        vm.uploadExcelFile = function () {
            try {
                DelaiFiduService.check(vm.delaiFiduciaire, vm.delaiFiduciaire.excelFile).then(function (response) {
                    var value = response.data;
                    var tmpExcelFile = vm.delaiFiduciaire.excelFile;
                    vm.delaiFiduciaire = value.delaiFiduciaire;
                    vm.delaiFiduciaire.excelFile = tmpExcelFile;
                    filterErrors(value.errors);
                    filterWarnings(value.warnings);
                    vm.formHelper.fileUploaded = true;
                }).catch(function (error) {
                    $log.error('Erreur appel ws /delaifiduciaire/check');
                    $log.error(error);
                    vm.formHelper.fileUploadError = ErrorUtil.translateError(error, ERROR_PREFIX + 'error.internalServerError', ERROR_PREFIX);
                });
            } catch (err) {
                vm.treatError(err, true);
            }
        };

        vm.sendRequest = function () {
            try {
                if (vm.formHelper.saveHeader) {
                    $window.localStorage.setItem(localStorageKey, JSON.stringify(vm.delaiFiduciaire.fiduciaire));
                } else {
                    $window.localStorage.removeItem(localStorageKey);
                }

                DelaiFiduService.create(vm.delaiFiduciaire, vm.delaiFiduciaire.excelFile).then(function () {
                    vm.formHelper.step = 2;
                    vm.sendHeightToParent();
                }).catch(function (error) {
                    $log.error('Erreur appel ws /delaifiduciaire');
                    vm.treatError(error);
                });
            } catch (err) {
                vm.treatError(err, true);
            }
        };

        vm.addEntry = function () {
            var lastEntry = vm.delaiFiduciaire.demandesDelai[vm.delaiFiduciaire.demandesDelai.length - 1];
            var newIndex = lastEntry.index + 1;
            vm.delaiFiduciaire.demandesDelai.push({index: newIndex});
            vm.sendHeightToParent();
        };

        vm.removeEntry = function (index) {
            var indexKey = null;
            angular.forEach(vm.delaiFiduciaire.demandesDelai, function (value, key) {
                if (value.index === index) {
                    indexKey = key;
                    return;
                }
            });
            vm.delaiFiduciaire.demandesDelai.splice(indexKey, 1);
            vm.sendHeightToParent();
        };

        vm.resetInputFile = function () {
            var excelInput = document.getElementById('excel');
            if (excelInput) {
                excelInput.value = '';
            }
            vm.formHelper.fileUploaded = false;
            vm.formHelper.fileUploadError = null;
        };

        vm.hasErrors = function (demandeDelai, fields) {
            var errorMessage = ValidationUtil.getValidationMessage(vm.errors, demandeDelai, fields);
            return !angular.isUndefined(errorMessage) && errorMessage !== null;
        };

        vm.hasWarnings = function (demandeDelai, fields) {
            if (vm.hasErrors(demandeDelai, fields)) {
                // Les erreurs sont prioritaires par rapport aux warning
                return false;
            }
            var warningMessage = ValidationUtil.getValidationMessage(vm.warnings, demandeDelai, fields);
            return !angular.isUndefined(warningMessage) && warningMessage !== null;
        };

        var trusted = {}
        vm.getValidationMessage = function (demandeDelai, fields) {
            var html = ValidationUtil.getValidationMessage(vm.errors, demandeDelai, fields);
            if (angular.isUndefined(html) || html === null) {
                html = ValidationUtil.getValidationMessage(vm.warnings, demandeDelai, fields);
            }
            // Caching nécessaire à cause du problème https://github.com/angular/angular.js/issues/3932
            return trusted[html] || (trusted[html] = $sce.trustAsHtml(html));
        };

        vm.resetForm = function () {
            vm.formHelper.fileUploadError = null;
            vm.delaiFiduciaire = angular.copy(delaiFiduciaireOriginal);
            vm.resetInputFile(document.getElementById('excel'));
            vm.$broadcast('show-errors-reset');
            vm.formHelper.showValidationMsg = false;
            vm.formHelper.errorMsg = null;
        };

        vm.printDiv = function (divId) {
            PrintUtil.printDiv(divId, 800, 600);
        };

        vm.onRecaptchaSuccess = function () {
            vm.formHelper.recaptchaSuccess = true;
            vm.formHelper.showValidationMsg = false;
        };

        vm.areItemsValid = function() {
            return (vm.delaifiduForm && !vm.delaifiduForm.$invalid) && (vm.formHelper.type === 'FORM' || vm.delaiFiduciaire.excelFile);
        };

        vm.isFormValid = function (skipCaptchaCheck) {
            var valid = vm.areItemsValid() && !ObjectUtils.isNonEmptyObject(vm.errors) && (skipCaptchaCheck || vm.formHelper.recaptchaSuccess) && !vm.formHelper.fileUploadError;
            if (valid) {
                vm.formHelper.showValidationMsg = false;
            }
            return valid;
        };

        vm.countNbDemandes = function() {
            if (vm.delaiFiduciaire && vm.delaiFiduciaire.demandesDelai) {
                return vm.delaiFiduciaire.demandesDelai.length;
            }
            return 0;
        };

        vm.showValidation = function(skipCaptchaCheck) {
            vm.formHelper.showValidationMsg = true;
            vm.isFormValid(skipCaptchaCheck);
            vm.$broadcast('show-errors-check-validity');
        };

        $interval(function(){
            vm.formHelper.valid = vm.isFormValid();
        }, 1000);

        //Fonction pour les appels depuis le template
        vm.sendHeightToParent = function() {
            IframeService.sendHeightToParent('delaifidu-form-content-wrapper');
        }

        var init = function() {
            vm.sendHeightToParent();
        }

        init();

    });
